module.exports = __webpack_public_path__ + "img/screen-manual-20.556cf01b.png";